// Import necessary functions from local components
import {showToast} from './toast';
import {trans} from '../i18n/i18n';
import {Toast} from "../consts/toast";

// Set up event listeners once the DOM content is fully loaded
document.addEventListener('DOMContentLoaded', function () {
    // Select all elements with the class 'js-copy-clipboard'
    const clipboardElements = document.querySelectorAll('.js-copy-clipboard');

    // Add a click event listener to each element
    clipboardElements.forEach(element => {
        element.addEventListener('click', function() {
            // Call the CopyToClipboard function and pass the text stored in data-copy attribute
            CopyToClipboard(this.dataset.copy);
        });
    });
});

/**
 * Copies the specified text to the clipboard and shows a toast notification based on the outcome.
 * @param {string} text - The text to be copied to the clipboard.
 */
function CopyToClipboard(text) {
    // Attempt to copy text to the clipboard using the Clipboard API
    navigator.clipboard.writeText(text)
        .then(() => {
            // If successful, display a success toast with a translated message
            showToast(trans("Successfully copied to clipboard"), Toast.SUCCESS);
        })
        .catch(err => {
            // If there's an error, log the error and display an error toast
            showToast(trans("Failed to copy to clipboard"), Toast.SUCCESS);
        });
}

// Export the CopyToClipboard function to be used elsewhere if necessary
export { CopyToClipboard };
